import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'upload-ui',
  templateUrl: './upload-ui.component.html',
  styleUrls: ['./upload-ui.component.scss']
})
export class UploadUiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
